import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchMemberShipAPI(filters) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/promotion/all/membership?${getQueryString(filters)}`);
}

export async function fetchMemberShipDetailsAPI(membershipId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/promotion/membership/${membershipId}`);
}

export async function addMemberShipAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/admin/promotion/membership`, data);
}

export async function updateMemberShipAPI(data, membershipId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/admin/promotion/membership/${membershipId}`, data);
}

export async function deleteMemberShipAPI(membershipId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`/api/v1/admin/promotion/membership/${membershipId}`);
}
